import React from "react";
import { useSelector } from "../../../app/helpers";
import { RootState } from "../../../app/rootReducer";
import type { DayWorkStatus } from "../types/dashboard2-work-status.types";
import { useDashboard2WelcomeMessage } from "../hooks/useDashboard2WelcomeMessage";
import { GoToManagementLink } from "../../Management/components/GoToManagementLink";
import { Dashboard2SectionIntro } from "./Dashboard2SectionIntro";
import { useTranslation } from "react-i18next";

type Dashboard2WelcomeBannerProps = {
  status: DayWorkStatus;
};

export const Dashboard2WelcomeBanner: React.FC<Dashboard2WelcomeBannerProps> = ({ status }) => {
  const { t } = useTranslation();
  const { firstName } = useSelector((state: RootState) => state.login.userInformation);
  const { isTenantAdmin, isCompanyAdmin } = useSelector(
    (state: RootState) => state.login.userRoles
  );
  const subMessage = useDashboard2WelcomeMessage(status);
  const displayName = firstName?.trim();
  const showManagementLink = isTenantAdmin || isCompanyAdmin;

  const title = displayName
    ? t("_dashboard2_welcomeGreeting", { name: displayName })
    : t("_dashboard2_welcomeGreetingAnonymous");

  if (!displayName && !subMessage && !showManagementLink) {
    return null;
  }

  const managementLink = showManagementLink ? (
    <GoToManagementLink data-testid="dashboard2-management-link" />
  ) : undefined;

  if (!displayName && !subMessage && managementLink) {
    return managementLink;
  }

  return (
    <Dashboard2SectionIntro
      title={title}
      description={subMessage || undefined}
      titleComponent="h1"
      density="page"
      action={managementLink}
      data-testid="dashboard2-welcome-banner"
    />
  );
};
